import { getNestedValue } from '../getNestedValue.js';
import { StandardCSSProperties } from '../types.js';
import { virtualTheme } from '../virtualTheme.js';

export function fromThemePaletteStyle(prop: keyof StandardCSSProperties): (
  value: string | number,
) => {
  className?: string;
  style?: StandardCSSProperties;
} {
  return (value) => {
    if (typeof value === 'number') {
      return {};
    }
    const fromTheme = getNestedValue(virtualTheme, `palette.${value}`);
    if (fromTheme) {
      return {
        style: {
          [prop]: fromTheme,
        },
      };
    }
    return {
      style: {
        [prop]: value,
      },
    };
  };
}
